// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editPhotosModal___sOrj {
  width: 720px;
}
@media (max-width: 701px) {
  .editPhotosModal___sOrj {
    width: 100%;
  }
}

.modalBody__fsXlG {
  flex: 1;
  padding: 0 25px;
}

.photoBlock__JvBoF {
  width: 100%;
  height: 284px;
  position: relative;
}

.mainPhoto__Re61p {
  width: 100%;
  height: 284px;
  object-fit: contain;
}

.emptyBlockPhotos__DqFS6 {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--inputs-default-text);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.photosListBlock__wYXEf {
  height: 64px;
  margin-top: 15px;
  gap: 8px;
  display: flex;
}

.photoItemWrapper__dYqen {
  width: 76px;
  height: 100%;
  position: relative;
  cursor: pointer;
}
.photoItemWrapper__dYqen:hover .deleteImageIcon__N9lAz {
  display: block;
}
.photoItemWrapper__dYqen:hover .deleteImageIcon__N9lAz rect {
  background: var(--tables-secondary-row-sub-title-surface);
}

.dropzone__G2Tk8 {
  margin-left: unset;
}

.gallerySwiper__PV6AI {
  width: 100%;
  height: 80px;
}
.gallerySwiper__PV6AI .swiper-wrapper {
  max-height: 64px;
}
.gallerySwiper__PV6AI .swiper-pagination-bullets {
  bottom: 1px !important;
  left: 43% !important;
  width: auto !important;
  display: flex;
}
.gallerySwiper__PV6AI .swiper-pagination-bullet {
  min-width: 16px;
  height: 3px;
  display: block;
  padding: 0;
  background: var(--tables-photo-gallery-pagination-default);
  transform: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  opacity: 1;
  cursor: pointer;
}
.gallerySwiper__PV6AI .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 11px;
  background: var(--tables-photo-gallery-pagination-active);
  border: none;
  cursor: auto;
}
.gallerySwiper__PV6AI .swiper-pagination-bullet-active-prev,
.gallerySwiper__PV6AI .swiper-pagination-bullet-active-next {
  transform: unset !important;
}
.gallerySwiper__PV6AI .swiper-pagination-bullet-active-prev-prev,
.gallerySwiper__PV6AI .swiper-pagination-bullet-active-next-next {
  transform: scaleX(0.3) !important;
}

.photoItem__uD_Tw {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.deleteImageIcon__N9lAz {
  display: none;
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  cursor: pointer;
}
.deleteImageIcon__N9lAz rect {
  fill-opacity: 1;
  fill: var(--tables-secondary-row-sub-title-surface);
}

.recoverImageBtn__RoMgA {
  font-size: 12px;
  color: var(--buttons-surface);
  padding: 2px 4px;
  background: var(--tables-secondary-row-sub-title-surface);
  border-radius: 4px;
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 3;
  cursor: pointer;
}

.modalFooter__vPsn9 {
  padding: 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

.cancelBtn__Bn4jQ {
  font-size: 12px;
  line-height: 12px;
  color: var(--buttons-surface);
  text-decoration: none;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.editBtn__r1yom {
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 26px;
  padding: 6px 12px;
  cursor: pointer;
  width: 160px;
  height: 44px;
  border-radius: 0;
  border: none;
  background-color: var(--buttons-surface);
}

.bodyRtl__yfZ6K .modal__head__maT4G .close-btn__XD8gh {
  left: 0;
  right: unset;
}

.deletedPhoto__t7POp {
  position: relative;
}
.deletedPhoto__t7POp::after {
  content: "";
  backdrop-filter: blur(3px);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditPhotosModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;AAzEF;AA2EE;EAHF;IAII,WAAA;EAxEF;AACF;;AA2EA;EACE,OAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAxEF;;AA0EA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAvEF;;AAyEA;EACE,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAtEF;;AAwEA;EACE,YAAA;EACA,gBAAA;EACA,QAAA;EACA,aAAA;AArEF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AArEF;AAwEI;EACE,cAAA;AAtEN;AAwEM;EACE,yDAAA;AAtER;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;AA4EI;EACE,gBAAA;AA1EN;AA6EI;EACE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;AA3EN;AA8EI;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,0DAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AA5EN;AA8EM;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,YAAA;AA5ER;AA+EI;;EAEE,2BAAA;AA7EN;AAgFI;;EAEE,iCAAA;AA9EN;;AAmFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAhFF;;AAkFA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AA/EF;AAiFE;EACE,eAAA;EACA,mDAAA;AA/EJ;;AAmFA;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,yDAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAhFF;;AAkFA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AA/EF;;AAkFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;AA/EF;;AAmFE;EACE,OAAA;EACA,YAAA;AAhFJ;;AAoFA;EACE,kBAAA;AAjFF;AAkFE;EACE,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAhFJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editPhotosModal {\n  width: 720px;\n\n  @media (max-width: 701px) {\n    width: 100%;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  padding: 0 25px;\n}\n\n.photoBlock {\n  width: 100%;\n  height: 284px;\n  position: relative;\n}\n.mainPhoto {\n  width: 100%;\n  height: 284px;\n  object-fit: contain;\n}\n.emptyBlockPhotos {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--inputs-default-text);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.photosListBlock {\n  height: 64px;\n  margin-top: 15px;\n  gap: 8px;\n  display: flex;\n}\n\n.photoItemWrapper {\n  width: 76px;\n  height: 100%;\n  position: relative;\n  cursor: pointer;\n\n  &:hover {\n    .deleteImageIcon {\n      display: block;\n\n      rect {\n        background: var(--tables-secondary-row-sub-title-surface);\n      }\n    }\n  }\n}\n\n.dropzone {\n  margin-left: unset;\n}\n\n.gallerySwiper {\n  width: 100%;\n  height: 80px;\n\n  :global {\n    .swiper-wrapper {\n      max-height: 64px;\n    }\n\n    .swiper-pagination-bullets {\n      bottom: 1px !important;\n      left: 43% !important;\n      width: auto !important;\n      display: flex;\n    }\n\n    .swiper-pagination-bullet {\n      min-width: 16px;\n      height: 3px;\n      display: block;\n      padding: 0;\n      background: var(--tables-photo-gallery-pagination-default);\n      transform: none;\n      border: none;\n      border-radius: 0;\n      box-shadow: none;\n      opacity: 1;\n      cursor: pointer;\n\n      &.swiper-pagination-bullet-active {\n        width: 11px;\n        background: var(--tables-photo-gallery-pagination-active);\n        border: none;\n        cursor: auto;\n      }\n    }\n    .swiper-pagination-bullet-active-prev,\n    .swiper-pagination-bullet-active-next {\n      transform: unset !important;\n    }\n\n    .swiper-pagination-bullet-active-prev-prev,\n    .swiper-pagination-bullet-active-next-next {\n      transform: scaleX(0.3) !important;\n    }\n  }\n}\n\n.photoItem {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.deleteImageIcon {\n  display: none;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 2;\n  cursor: pointer;\n\n  rect {\n    fill-opacity: 1;\n    fill: var(--tables-secondary-row-sub-title-surface);\n  }\n}\n\n.recoverImageBtn {\n  font-size: 12px;\n  color: var(--buttons-surface);\n  padding: 2px 4px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 4px;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 3;\n  cursor: pointer;\n}\n\n.modalFooter {\n  padding: 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n.cancelBtn {\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  text-decoration: none;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.editBtn {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 26px;\n  padding: 6px 12px;\n  cursor: pointer;\n  width: 160px;\n  height: 44px;\n  border-radius: 0;\n  border: none;\n  background-color: var(--buttons-surface);\n}\n\n.bodyRtl {\n  .modal__head .close-btn {\n    left: 0;\n    right: unset;\n  }\n}\n\n.deletedPhoto {\n  position: relative;\n  &::after {\n    content: '';\n    backdrop-filter: blur(3px);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editPhotosModal": `editPhotosModal___sOrj`,
	"modalBody": `modalBody__fsXlG`,
	"photoBlock": `photoBlock__JvBoF`,
	"mainPhoto": `mainPhoto__Re61p`,
	"emptyBlockPhotos": `emptyBlockPhotos__DqFS6`,
	"photosListBlock": `photosListBlock__wYXEf`,
	"photoItemWrapper": `photoItemWrapper__dYqen`,
	"deleteImageIcon": `deleteImageIcon__N9lAz`,
	"dropzone": `dropzone__G2Tk8`,
	"gallerySwiper": `gallerySwiper__PV6AI`,
	"photoItem": `photoItem__uD_Tw`,
	"recoverImageBtn": `recoverImageBtn__RoMgA`,
	"modalFooter": `modalFooter__vPsn9`,
	"cancelBtn": `cancelBtn__Bn4jQ`,
	"editBtn": `editBtn__r1yom`,
	"bodyRtl": `bodyRtl__yfZ6K`,
	"modalHead": `modal__head__maT4G`,
	"closeBtn": `close-btn__XD8gh`,
	"deletedPhoto": `deletedPhoto__t7POp`
};
module.exports = ___CSS_LOADER_EXPORT___;
